import { Link } from 'react-router-dom';
import { MapPin, Phone, Clock, Facebook, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1C1917] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & Description */}
          <div className="lg:col-span-1">
            <h3 className="font-['Playfair_Display'] text-2xl font-bold mb-4">
              NotaBene <span className="text-[#C62E2E]">Sympho</span>
            </h3>
            <p className="text-stone-400 leading-relaxed">
              Restaurant italien authentique à Mons. Pizzas au feu de bois, pâtes maison et ambiance chaleureuse depuis plus de 20 ans.
            </p>
            <div className="flex gap-4 mt-6">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#C62E2E] transition-colors"
                data-testid="footer-facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#C62E2E] transition-colors"
                data-testid="footer-instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-stone-400 hover:text-white transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/restaurant" className="text-stone-400 hover:text-white transition-colors">
                  Le Restaurant
                </Link>
              </li>
              <li>
                <Link to="/reservation" className="text-stone-400 hover:text-white transition-colors">
                  Réserver
                </Link>
              </li>
              <li>
                <Link to="/commander" className="text-stone-400 hover:text-white transition-colors">
                  Commander
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-stone-400 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#C62E2E] flex-shrink-0 mt-0.5" />
                <span className="text-stone-400">
                  Chaussée du Roi Baudouin 161,<br />
                  7030 Mons, Belgique
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-[#C62E2E] flex-shrink-0" />
                <a href="tel:+3265950649" className="text-stone-400 hover:text-white transition-colors">
                  065 95 06 49
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Horaires</h4>
            <ul className="space-y-2 text-stone-400">
              <li className="flex justify-between">
                <span>Lundi</span>
                <span className="text-[#C62E2E]">Fermé</span>
              </li>
              <li className="flex justify-between">
                <span>Mardi</span>
                <span className="text-[#C62E2E]">Fermé</span>
              </li>
              <li className="flex justify-between">
                <span>Mer - Dim</span>
                <span>12h-14h30</span>
              </li>
              <li className="flex justify-between">
                <span></span>
                <span>18h-22h</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-stone-500 text-sm">
            © {new Date().getFullYear()} NotaBene Sympho. Tous droits réservés.
          </p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-stone-400 text-sm">
            <Link to="/mentions-legales" className="hover:text-white transition-colors" data-testid="footer-mentions-legales">
              Mentions légales
            </Link>
            <span className="text-stone-600">•</span>
            <Link to="/cgv" className="hover:text-white transition-colors" data-testid="footer-cgv">
              CGV
            </Link>
            <span className="text-stone-600">•</span>
            <Link to="/politique-confidentialite" className="hover:text-white transition-colors" data-testid="footer-rgpd">
              Confidentialité (RGPD)
            </Link>
            <span className="text-stone-600">•</span>
            <Link to="/politique-cookies" className="hover:text-white transition-colors" data-testid="footer-cookies">
              Cookies
            </Link>
          </div>
        </div>
        <div className="text-center mt-6">
          <div className="inline-flex items-center gap-2 text-stone-500 text-sm">
            <Clock className="w-4 h-4" />
            <span>Noté 4.3/5 sur Google (228 avis)</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
